// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"/user","layout":false,"id":"1"},"2":{"name":"login","path":"/user/login","parentId":"1","id":"2"},"3":{"name":"register","path":"/user/register","parentId":"1","id":"3"},"4":{"path":"/welcome","name":"welcome","icon":"DashboardOutlined","parentId":"ant-design-pro-layout","id":"4"},"5":{"path":"/corp","name":"corp","icon":"TeamOutlined","parentId":"ant-design-pro-layout","id":"5"},"6":{"path":"/account","name":"account","icon":"UserOutlined","parentId":"ant-design-pro-layout","id":"6"},"7":{"path":"/","redirect":"/welcome","parentId":"ant-design-pro-layout","id":"7"},"8":{"path":"*","layout":false,"id":"8"},"ant-design-pro-layout":{"id":"ant-design-pro-layout","path":"/","isLayout":true}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import('./EmptyRoute')),
'2': React.lazy(() => import(/* webpackChunkName: "p__user__login__index" */'@/pages/user/login/index.tsx')),
'3': React.lazy(() => import(/* webpackChunkName: "p__user__register__index" */'@/pages/user/register/index.tsx')),
'4': React.lazy(() => import(/* webpackChunkName: "p__Welcome" */'@/pages/Welcome.tsx')),
'5': React.lazy(() => import(/* webpackChunkName: "p__corp__index" */'@/pages/corp/index.tsx')),
'6': React.lazy(() => import(/* webpackChunkName: "p__account__index" */'@/pages/account/index.tsx')),
'7': React.lazy(() => import('./EmptyRoute')),
'8': React.lazy(() => import(/* webpackChunkName: "p__404" */'@/pages/404.tsx')),
'ant-design-pro-layout': React.lazy(() => import(/* webpackChunkName: "t__plugin-layout__Layout" */'/root/workspace/csida-studio_8pD0/src/.umi-production/plugin-layout/Layout.tsx')),
},
  };
}
